'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsletterController = function () {
  function NewsletterController(NewsletterDataProvider, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, NewsletterController);
    this.NewsletterDataProvider = NewsletterDataProvider;
    this.$state = $state;
    var vm = this;
    vm.submitMsg = 0;
    NewsletterDataProvider.editor();
    vm.NewsletterDataProvider.getNewsletter('newsletter').then(function (result) {
      vm.newsletter = result;
      vm.setEditorsData();
    });
  }

  (0, _createClass3.default)(NewsletterController, [{
    key: 'send',
    value: function send(form) {
      if (!form) {
        return false;
      }
      var vm = this;
      vm.NewsletterDataProvider.sendNewsletter().then(function (res) {
        vm.submitMsg = 1;
      });
    }
  }, {
    key: 'getEditorsData',
    value: function getEditorsData() {
      this.newsletter.data = tinyMCE.get('newsletter_text').getContent();
    }
  }, {
    key: 'setEditorsData',
    value: function setEditorsData() {
      tinyMCE.get('newsletter_text').setContent(this.newsletter.data);
    }
  }]);
  return NewsletterController;
}();

// WEBPACK FOOTER //


exports.default = NewsletterController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/newsletter/components/send/controller.js
 **/